import Http from '@/services/http';
import { modulesMap, EngineeringModulesRequest } from 'sigma-mappings';

const urls = {
  modules: '/engenharia/chroma/modulos',
};

export default {
  getEngineeringModules(payload) {
    const http = new Http();
    const mappedPayload = new EngineeringModulesRequest(payload);
    return http.post(urls.modules, mappedPayload).then(
      ({ data }) => data.map(item => modulesMap[item]),
    );
  },
};
